import SyncToast from './SyncToast.container'

export default SyncToast
